/**
 * AuthWrapper Component - Handles Login/Register Toggle
 */

import React, { useState } from 'react';
import { Login } from './Login';
import { SignUp } from './SignUp';

export const AuthWrapper: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);

  const toggleMode = () => {
    setIsLogin(!isLogin);
  };

  if (isLogin) {
    return <Login onToggleMode={toggleMode} />;
  }

  // Show signup form
  return <SignUp onToggleMode={toggleMode} />;
};
